export enum FormatTyp {
  TYP1 = 'TYP1',
  TYP2 = 'TYP2',
  TYP3 = 'TYP3',
  TYP4 = 'TYP4',
}

export enum TypInterwalu {
  INTERWAL = 'INTERWAL',
  HARMONOGRAM = 'HARMONOGRAM',
}

export enum RcpFiltr {
  WSZYSTKIE = 'WSZYSTKIE',
  TAK = 'TAK',
  NIE = 'NIE',
}

export type AutoExportRunningState = 'STARTED' | 'STOPPED';
